import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import {
  stockReportsControllerGetCurrentValue,
  stockReportsControllerGetExpiring,
  stockReportsControllerGetInventoryValuation,
  stockReportsControllerGetLowStock,
  stockReportsControllerGetMovements,
  StockReportsControllerGetMovements$Params,
} from '@klubovna/api-client';
import { ExpiringItemDto, InventoryValuationResponseDto, LowStockItemDto, MovementsReportDto, StockValueResponseDto } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class StockReportsApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  getCurrentValue(): Observable<StockValueResponseDto> {
    return stockReportsControllerGetCurrentValue(this.http, this.apiConfig.rootUrl)
      .pipe(map(response => response.body));
  }

  getLowStock(): Observable<LowStockItemDto[]> {
    return stockReportsControllerGetLowStock(this.http, this.apiConfig.rootUrl)
      .pipe(map(response => response.body));
  }

  getExpiring(): Observable<ExpiringItemDto[]> {
    return stockReportsControllerGetExpiring(this.http, this.apiConfig.rootUrl)
      .pipe(map(response => response.body));
  }

  getMovements(params: StockReportsControllerGetMovements$Params): Observable<MovementsReportDto> {
    return stockReportsControllerGetMovements(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body));
  }

  getInventoryValuation(): Observable<InventoryValuationResponseDto> {
    return stockReportsControllerGetInventoryValuation(this.http, this.apiConfig.rootUrl)
      .pipe(map(response => response.body));
  }
}
